import React, { memo, useContext, useMemo } from 'react'
import { CircleTickMinor } from '@shopify/polaris-icons'
import { TableSelect } from 'src/components/shared/table/TableSelect'
import { LinkSubcontractorTableContext } from '../LinkSubcontractorTable.context'
import { SubcontractorRequestStatus } from 'src/constants/subcontractorRequests/enum'
import { SubcontractorStatusChip } from '../../shared/SubcontractorStatusChip'

const LinkSubcontractorContractorStatusSelectComponent = () => {
  const { statusFilter, setStatusFilter } = useContext(LinkSubcontractorTableContext)

  const statuses = useMemo(() => {
    return Object.values(SubcontractorRequestStatus).map((status) => ({
      value: status,
      component: <SubcontractorStatusChip status={status} />,
    }))
  }, [])

  return (
    <TableSelect<SubcontractorRequestStatus>
      title="Status"
      selectedValues={statusFilter}
      icon={<CircleTickMinor width={20} />}
      options={statuses}
      onSelect={setStatusFilter}
      emptyText="No statuses available"
    />
  )
}

export const LinkSubcontractorContractorStatusSelect = memo(
  LinkSubcontractorContractorStatusSelectComponent,
)
